import { useState } from "react";
import { Get } from "../../../../Request";
import toast from "react-hot-toast";

export const useWeblog = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const getData = async (data, item, day) => {
    setLoading(true);
    Get({
      url: "/blog/webblog",
    }).then(result => {
      setLoading(false);
      setData(result);
    });
  };
  return {
    data,
    loading,
    getData,
  };
};
